import React from 'react';
import { VendorInvoicesTab } from '../stores/VendorInvoicesTab';

export default function VendorInvoices() {
  return <div className="p-6" data-testid="vendor-invoices-page"><VendorInvoicesTab /></div>;
}
